import React from "react";
import "./Button.css";

const Button = ({ variant = "primary", className = "", children, ...rest }) => (
  <button
    type="button"
    className={`app-btn app-btn--${variant} ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export default Button;
